import { render } from "./UserProfileExternOfEnterprise.vue?vue&type=template&id=1ca1406e&ts=true"
import script from "./UserProfileExternOfEnterprise.vue?vue&type=script&lang=ts"
export * from "./UserProfileExternOfEnterprise.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__